import React from "react";
import { cn } from "../../../lib/utils";
import { FIELD } from "./classes";

/**
 * A styled NATIVE `<select>` with the wireframes' "▾" caret.
 *
 * Native on purpose: it is keyboard- and screen-reader-complete on every platform, the
 * phone opens its own picker (the Today zone is mobile-first), and it behaves in jsdom,
 * where Radix Select's pointer model does not.
 *
 * `options` is `[{value, label, disabled?}]`; the labels are already translated.
 */
const CrmSelect = React.forwardRef(function CrmSelect(
  { options = [], className, selectClassName, placeholder, value, ...rest },
  ref,
) {
  return (
    <span className={cn("relative inline-flex", className)}>
      <select
        ref={ref}
        value={value}
        className={cn(FIELD, "appearance-none pr-8 cursor-pointer", selectClassName)}
        {...rest}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={String(o.value)} value={o.value} disabled={o.disabled}>{o.label}</option>
        ))}
      </select>
      <span aria-hidden="true" className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[10px] text-eh-ink">▾</span>
    </span>
  );
});

export default CrmSelect;
